<template>
  <v-expansion-panel
    class="paper"
    role="button"
  >
    <v-expansion-panel-header class="content">
      <span class="heading">
        <slot name="title"/>
      </span>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="detail">
      <span>
        <slot name="text"/>
      </span>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
  @import '../../assets/styles.scss';
  @import 'faq-style.scss';
</style>
<script>
  export default {
    methods: {
      genKey() {
        return _.random(1, 9999999)
      }
    }
  }
</script>
